import { render, staticRenderFns } from "./CorrectListDetails.vue?vue&type=template&id=18f8374c&scoped=true"
import script from "./CorrectListDetails.vue?vue&type=script&lang=js"
export * from "./CorrectListDetails.vue?vue&type=script&lang=js"
import style0 from "./CorrectListDetails.vue?vue&type=style&index=0&id=18f8374c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8374c",
  null
  
)

export default component.exports